<mat-card (click)="openModal()">
  <div class="earn-title">博主/群主专属扶持计划</div>
  <div class="earn-desc">
    拥有粉丝基础？为您开通<b>专属高佣通道</b>与<b>定制推广方案</b>，让您的每一份流量都更值钱。
  </div>
  <div class="earn-cta">扫码洽谈专属合作 &rarr;</div>
  <div class="earn-bg-icon">💰</div>
</mat-card>
